var path = '/advisor/sidepanel/advisorStatements/advisorStatementsSearch.tpl.html';
var html = "<div data-ng-if=\"advisorStatementsSearchController.isLoaded && \n                advisorStatementsSearchController.configuration\n                  [advisorStatementsSearchController.tabIdList.stmts.toUpperCase()]\n                  [advisorStatementsSearchController.constants.VISIBLE]\" data-ifast-grid data-ifast-object-id=\"{{advisorStatementsSearchController.StmtSlipsModal + 'Stmts'}}\" data-ifast-options=advisorStatementsSearchController.gridOptions data-ifast-toolbar-template=advisorStatementsSearchToolBar.tpl.html class=ifds-advanceQueryFilter></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./WebContent/src/advisor/sidepanel/advisorStatements/advisorStatementsSearch.tpl.html
// module id = 556
// module chunks = 0 2